// Pop Panda Flavour Creator Studio — Full Ingredient Library (90+ items)

export const INGREDIENT_GROUPS = [
  {
    key: "fruit",
    label: "Fruits",
    color: "#FF6B6B",
    items: [
      "Mango", "Strawberry", "Pineapple", "Guava", "Lychee", "Dragon Fruit",
      "Blueberry", "Raspberry", "Peach", "Apple", "Papaya", "Custard Apple",
      "Watermelon", "Muskmelon", "Pomegranate", "Orange", "Mosambi", "Grapes",
      "Jamun", "Amla", "Kiwi", "Passion Fruit", "Cherry", "Fig", "Banana",
    ],
  },
  {
    key: "dairy",
    label: "Dairy & Creamy",
    color: "#F5E6C8",
    items: [
      "Milk", "Vanilla", "Chocolate", "White Chocolate", "Dark Chocolate",
      "Caramel", "Butterscotch", "Coffee", "Mocha", "Cream Cheese",
      "Fresh Cream", "Condensed Milk", "Yogurt", "Kulfi Base", "Rabdi Base",
    ],
  },
  {
    key: "biscuit",
    label: "Biscuits & Cookies",
    color: "#D6B85A",
    items: [
      "Oreo", "Bourbon", "Marie Gold", "Good Day", "Digestive Biscuit",
      "Chocolate Chip Cookies", "Butter Cookies", "Wafer Biscuit",
      "Lotus Biscoff", "Cookie Crumble",
    ],
  },
  {
    key: "drynut",
    label: "Dry Fruits & Nuts",
    color: "#A07F58",
    items: [
      "Almond", "Cashew", "Pistachio", "Walnut", "Peanut", "Hazelnut",
      "Dates", "Raisins", "Figs", "Mixed Dry Fruits",
    ],
  },
  {
    key: "indian",
    label: "Indian Classics",
    color: "#E27D9C",
    items: [
      "Elaichi", "Saffron", "Rose", "Gulkand", "Pan", "Tender Coconut",
      "Jaggery", "Badam Milk", "Kesar Pista", "Kulfi Masala",
    ],
  },
  {
    key: "fun",
    label: "Fun & Innovative",
    color: "#7DD3C0",
    items: [
      "Bubble Gum", "Cotton Candy", "Cola", "Energy Drink Inspired",
      "Mint Blast", "Lemon Mint", "Ginger Lemon", "Chocolate Mint",
      "Salted Caramel", "Choco Coffee",
    ],
  },
  {
    key: "premium",
    label: "Premium Desserts",
    color: "#5B3924",
    items: [
      "Tiramisu", "Cheesecake", "Brownie", "Chocolate Truffle", "Red Velvet",
      "Black Forest", "Ferrero Inspired", "Caramel Crunch", "Choco Almond",
      "Cookies & Cream",
    ],
  },
];

export const ALL_INGREDIENTS = INGREDIENT_GROUPS.flatMap((g) =>
  g.items.map((i) => ({ name: i, group: g.key, color: g.color }))
);

export const CATEGORY_WORLDS = {
  water: {
    slug: "water",
    label: "Water-Based",
    cta: "Explore Refreshing Flavours",
    theme: "Summer · Childhood · Outdoors",
    headline: "Every Summer Has a Story",
    sub: "The taste of sunshine, laughter and unforgettable childhood memories.",
    accent: "#74C0FC",
    bg: "linear-gradient(180deg, #FFF8F0 0%, #D7F2FF 100%)",
    hero: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=1600&auto=format&fit=crop",
    vibes: [
      { img: "https://images.unsplash.com/photo-1530041686259-53b9b964dfa3?q=80&w=900&auto=format&fit=crop", caption: "Bicycle vendors. Paper wrappers." },
      { img: "https://images.unsplash.com/photo-1455644210018-32279d8c734f?q=80&w=900&auto=format&fit=crop", caption: "Kites at Kaup beach." },
      { img: "https://images.unsplash.com/photo-1593069547138-a7f6f5c50f48?q=80&w=900&auto=format&fit=crop", caption: "Park benches. Sticky fingers." },
      { img: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?q=80&w=900&auto=format&fit=crop", caption: "Family outings. Slow afternoons." },
    ],
  },
  milk: {
    slug: "milk",
    label: "Milk-Based",
    cta: "Discover Creamy Delights",
    theme: "Comfort · Family · Together",
    headline: "Comfort Frozen Into Every Bite",
    sub: "Rich, creamy moments made for sharing.",
    accent: "#F5E6C8",
    bg: "linear-gradient(180deg, #FFF8F0 0%, #FFEACB 100%)",
    hero: "https://images.unsplash.com/photo-1488477181946-6428a0291777?q=80&w=1600&auto=format&fit=crop",
    vibes: [
      { img: "https://images.unsplash.com/photo-1611077881026-7ec9f1d77fd2?q=80&w=900&auto=format&fit=crop", caption: "Long verandas. Lazy Sundays." },
      { img: "https://images.unsplash.com/photo-1559781867-8b32acc7b73c?q=80&w=900&auto=format&fit=crop", caption: "Brothers, sisters, sharing one stick." },
      { img: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=900&auto=format&fit=crop", caption: "Warm rooms. Cold pops." },
      { img: "https://images.unsplash.com/photo-1488900128323-21503983a07e?q=80&w=900&auto=format&fit=crop", caption: "Cream, slow-set, careful." },
    ],
  },
  creamy: {
    slug: "creamy",
    label: "Premium Creamy Collection",
    cta: "Explore Premium Creations",
    theme: "Luxury · Indulgence · Slow",
    headline: "Crafted Beyond Ordinary",
    sub: "For moments that deserve something extraordinary.",
    accent: "#5B3924",
    bg: "linear-gradient(180deg, #2B2B2B 0%, #4a3a2a 100%)",
    dark: true,
    hero: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?q=80&w=1600&auto=format&fit=crop",
    vibes: [
      { img: "https://images.unsplash.com/photo-1568826939341-7a86e8f73a31?q=80&w=900&auto=format&fit=crop", caption: "Single-origin chocolate." },
      { img: "https://images.unsplash.com/photo-1582716401301-b2407dc7563d?q=80&w=900&auto=format&fit=crop", caption: "Slow folded cream." },
      { img: "https://images.unsplash.com/photo-1571805341302-f857810cf69d?q=80&w=900&auto=format&fit=crop", caption: "Edges of a celebration." },
      { img: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?q=80&w=900&auto=format&fit=crop", caption: "Late dinners. Soft lights." },
    ],
  },
  innovation: {
    slug: "innovation",
    label: "Innovation Series",
    cta: "See What's New",
    theme: "Future · Discovery · Lab",
    headline: "Where Imagination Becomes a Popsicle",
    sub: "The home of new ideas, seasonal surprises and future favourites.",
    accent: "#FFC93C",
    bg: "linear-gradient(180deg, #FFF8F0 0%, #FFF1D6 100%)",
    hero: "https://images.unsplash.com/photo-1605781231474-f60dea478e8a?q=80&w=1600&auto=format&fit=crop",
    vibes: [
      { img: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?q=80&w=900&auto=format&fit=crop", caption: "Concept boards on the wall." },
      { img: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?q=80&w=900&auto=format&fit=crop", caption: "Prototype #207. Test 3." },
      { img: "https://images.unsplash.com/photo-1497515114629-f71d768fd07c?q=80&w=900&auto=format&fit=crop", caption: "Cold-brew rigs." },
      { img: "https://images.unsplash.com/photo-1488900128323-21503983a07e?q=80&w=900&auto=format&fit=crop", caption: "Limited drops. Always." },
    ],
  },
  zero_sugar: {
    slug: "zero_sugar",
    label: "Reduced Sugar Collection",
    cta: "Explore Better Choices",
    theme: "Wellness · Lifestyle · Fresh",
    headline: "Feel Good, Taste Great",
    sub: "Refreshing enjoyment designed for modern lifestyles.",
    accent: "#7DD3C0",
    bg: "linear-gradient(180deg, #FFF8F0 0%, #E8F7EF 100%)",
    hero: "https://images.unsplash.com/photo-1488900128323-21503983a07e?q=80&w=1600&auto=format&fit=crop",
    vibes: [
      { img: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=900&auto=format&fit=crop", caption: "Morning walks." },
      { img: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?q=80&w=900&auto=format&fit=crop", caption: "Quiet wellness." },
      { img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=900&auto=format&fit=crop", caption: "Honest labels." },
      { img: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=900&auto=format&fit=crop", caption: "Outdoor afternoons." },
    ],
  },
};

export const CATEGORY_ORDER = ["water", "milk", "creamy", "innovation", "zero_sugar"];

export const JOURNEY_STAGES = [
  { key: "idea_submitted", label: "Idea Submitted" },
  { key: "under_review", label: "Under Review" },
  { key: "testing", label: "Testing" },
  { key: "prototype_created", label: "Prototype Created" },
  { key: "customer_trial", label: "Customer Trial" },
  { key: "production_approved", label: "Production Approved" },
  { key: "available_in_stores", label: "Available in Stores" },
];

export const PRIVATE_NOTICE = {
  short: "Flavours vary by location, season, innovation projects and production schedules.",
  long: "Available flavours vary by location, season, innovation projects, and production schedules. Visit your nearest outlet or contact us to discover today's available flavours.",
};
